import { Button } from '@travelnest/merlin.button';
import * as React from 'react';
import { IBookingReceipt } from '../../../data/entities/event/booking';
import { ActionTypes } from '../../../entities/bookings/actions';
import { currencySymbolForCurrencyString } from '../../helpers/currency_helpers';
import { useReduxAction } from '../../helpers/hooks';
import { Content } from '../page/content/Content';
import { calculateOutstanding, getNextWednesday, IPendingBookingReceipt } from './helpers';
import { ReceiptInputForm } from './ReceiptInputForm';
import { ReceiptTable } from './ReceiptTable';

interface IOwnerPaymentProps {
	defaultCurrency: string;
	totalValue: number;
	totalPaymentPreCommission?: number;
	totalCommission?: number;
	receipts: IBookingReceipt[];
	setReceipts: (receipts: IPendingBookingReceipt[]) => any;
}

export const OwnerPayment: React.FC<IOwnerPaymentProps> = (props) => {
	const defaultAmount = calculateOutstanding(props.totalValue, props.receipts);
	const baseReceipt = {
		currency: props.defaultCurrency,
		amount: defaultAmount,
		date: getNextWednesday(),
		method: 'bank_transfer',
		reference: 'Balance to owner',
		pending: true
	} as IPendingBookingReceipt;

	const [showInput, setShowInput] = React.useState(false);
	const [ownerPayment, setOwnerPayment] = React.useState({ ...baseReceipt });

	const submitReceipt = (receipt: IPendingBookingReceipt) => {

		const added = JSON.parse(sessionStorage.getItem('added_owner_payments') || '[]');
		added.push(receipt);

		sessionStorage.setItem('added_owner_payments', JSON.stringify(added));

		props.setReceipts([...props.receipts, receipt]);
		setOwnerPayment({ ...baseReceipt });
	};

	const deleteReceipt = (targetReceipt: IPendingBookingReceipt, del: boolean = true) => {
		let deleted = JSON.parse(sessionStorage.getItem('deleted_owner_payments') || '[]');
		if (del) {
			deleted.push(targetReceipt);
		} else {
			deleted = deleted.filter((receipt: IPendingBookingReceipt) => JSON.stringify({ ...receipt, deleted: true }) !== JSON.stringify(targetReceipt));
		}
		sessionStorage.setItem('deleted_owner_payments', JSON.stringify(deleted));

		props.setReceipts(props.receipts.map(
			(receipt) => receipt === targetReceipt ? { ...receipt, deleted: del } : receipt
		));
	};

	const copyReceipt = (receipt: IBookingReceipt) => {
		setOwnerPayment({ ...receipt, pending: true });
		setShowInput(true);
	};

	const clearPending = () => props.setReceipts(props.receipts.map((receipt) => ({ ...receipt, pending: false })));

	useReduxAction(ActionTypes.BOOKINGV2_UPDATE_RECEIVE, () => clearPending());

	return <Content type="full">
		<div className="booking-payment__header">
			<div className="booking-payment__title"><h2>Owner payments</h2></div>
			<div className="booking-payment__title--button"><Button onClick={(e) => setShowInput(!showInput)}>
				{showInput ? 'Close' : 'Add'}</Button>
			</div>
		</div>

		{
			showInput &&
			<ReceiptInputForm
				defaultCurrency={props.defaultCurrency}
				lockCurrency={true}
				defaultAmount={defaultAmount}
				paymentMethods={['bank_transfer']}
				receipt={ownerPayment}
				setReceipt={setOwnerPayment}
				submitReceipt={submitReceipt}
			/>
		}

		<ReceiptTable
			receipts={props.receipts}
			deleteReceipt={deleteReceipt}
			copyReceipt={copyReceipt}
			metadata={{
				'Remaining':
					currencySymbolForCurrencyString(props.defaultCurrency) +
					calculateOutstanding(props.totalValue, props.receipts).toFixed(2),
				'Total Payment Pre-Commission':
					currencySymbolForCurrencyString(props.defaultCurrency) +
					(props.totalPaymentPreCommission || 0).toFixed(2),
				'Total Commission':
					currencySymbolForCurrencyString(props.defaultCurrency) +
					(props.totalCommission || 0).toFixed(2)
			}}
		/>

	</Content>;
};
